import { BASE_URL } from './babydogeswap'

export const BABYDOGE_DEFAULT_TOKENS = `${BASE_URL}/babydogeswap-default.json`
export const BABYDOGE_TOP100 = `${BASE_URL}/babydogeswap-top100.json`
// const BABYDOGE_EXTENDED = `${BASE_URL}/babydogeswap-extended.json`;
export const COINGECKO_TOKENS = 'https://tokens.babydogenews.com/coingecko.json'

export const UNSUPPORTED_LIST_URLS: string[] = [
  'https://tokens.babydogenews.com/babydoge_unsupported_tokens.json',
]

export const TOKEN_IMAGE_API = 'https://tokens.babydogenews.com/'

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [
  BABYDOGE_TOP100,
  // BABYDOGE_EXTENDED,
  COINGECKO_TOKENS,
]

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = []

